export enum EventType {
    Mobile = 'Mobile',
    MobileKit = 'Mobile Kit',
    Test = 'Test',
    Produced = 'Produced',
    Simulated = 'Simulated',
    Static = 'Static',
    External = 'External',
    Regular = 'regular',
    ClientBooking = 'client booking',

    CB1 = 'cb1', // legacy, check for removal
    CB2 = 'cb2', // legacy, check for removal
    CB3 = 'cb3' // legacy, check for removal
}

export namespace EventType {
    export const keys = {
        Mobile: 'Mobile',
        MobileKit: 'Mobile Kit',
        Test: 'Test',
        Produced: 'Produced',
        Simulated: 'Simulated',
        Static: 'Static',
        External: 'External',
        regular: 'Regular',
        ClientBooking: 'Client Booking',

        cb1: 'Client Booking 1', // legacy, check for removal
        cb2: 'Client Booking 2', // legacy, check for removal
        cb3: 'Client Booking 3' // legacy, check for removal
    } as const;

    export type Key = keyof typeof keys;
    export type Value = typeof keys[keyof typeof keys];
}
